import React, { Component } from 'react';
import "react-table-6/react-table.css";
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { Progress } from 'react-sweet-progress';
import "react-sweet-progress/lib/style.css";

class Build extends Component {
  constructor() {
    super();
    this.state = {
      percentage: 0,
      voicePercentage: 0,
      status: null,
      voiceStatus: null,
      contentEditable: "false",
      successResp: false,
      progressBar: false,
      voiceProgressBar: false,
      totalEntitiesTobeParsed: 0,
      voiceTotalEntitiesTobeParsed: 0,
      numEntitiesParsed: 0,
      voiceNumEntitiesParsed: 0,
      details: "",
      lastBuildBy: "",
      lastBuildDate: "",
      recordsPresent: false,
      isCleanBuild: false,
      isBuildInProgress: false,
      isVoiceBuildInProgress: false,
      enableVoice: false
    },
      this.buildSuccess = false
  }

  printGeneralErrorMessage() {
    toast(<b style={{ color: "red" }}>Oops! Error occurred. Please try again</b>, {
      position: "top-center",
      color: "red"

    });
  }

  printBuildErrorMessage(message) {
    toast(<b style={{ color: "red" }}>{message}</b>, {
      position: "top-center",
      color: "red"

    });
  }

  printBuildStatusFetchError() {
    toast(<b style={{ color: "red" }}>Snap! Some error occured when trying to get build status...</b>, {
      position: "top-center",
      color: "red"

    });
  }

  startBuildApi = () => {
    let buildController = this;
    buildController.state.isBuildInProgress = true;
    buildController.setState(buildController.state);
    let data = {
      projectId: localStorage.getItem("currentProjectId"),
      cleanBuild: buildController.state.isCleanBuild
    }
    $.ajax({
      url: "/api/start-build",
      type: 'GET',
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("access_token")
      },
      data: data,
      success: function (res) {
        if (res.success === true) {
          res = res.result;
          buildController.state.percentage = res.percentage;
          buildController.state.buildId = res.buildId;
          buildController.state.startTime = res.startTime;
          buildController.state.totalEntitiesTobeParsed = res.totalEntitiesTobeParsed;
          buildController.state.numEntitiesParsed = res.numEntitiesParsed;
          buildController.state.status = res.status;
          buildController.setState(buildController.state);
          if (res.status != 'COMPLETE') {
            window.buildStatusTimeoutHandle = setInterval(function () {
              buildController.buildStatusApi();
            }, 1000);
          }
          if (res.voiceEnabled) {
            window.voiceBuildStatusTimeoutHandle = setInterval(function () {
              buildController.voiceBuildStatusApi(res.voiceBuildId);
            }, 1000);
          }

        } else {
          buildController.state.isBuildInProgress = false;
          buildController.state.voiceProgressBar = false;
          buildController.setState({
            progressBar: false
          });
          buildController.printBuildErrorMessage(res.result);
        }
      }
    });
  }

  buildStatusApi = () => {
    let buildController = this;
    buildController.state.isBuildInProgress = true;
    buildController.setState(buildController.state);
    $.ajax({
      url: "/api/build-status",
      type: 'GET',
      async: false,
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("access_token")
      },
      data: {
        buildId: buildController.state.buildId
      },
      success: function (res) {
        if (res.success === true) {
          res = res.result;
          buildController.state.percentage = res.percentage;
          buildController.state.numEntitiesParsed = res.numEntitiesParsed;
          buildController.state.status = res.status;
          if (buildController.state.totalEntitiesTobeParsed == 0) {
            buildController.state.totalEntitiesTobeParsed = res.totalEntitiesTobeParsed;
            buildController.setState(buildController.state);
          }
          if (res.status == 'COMPLETE') {
            clearTimeout(window.buildStatusTimeoutHandle);
            buildController.buildSuccess = true;
            buildController.state.isBuildInProgress = false;
            buildController.setLastBuildInfo(res);
          } else if (res.status == 'ERROR') {
            clearTimeout(window.buildStatusTimeoutHandle);
            buildController.state.isBuildInProgress = false;
            buildController.setState({
              progressBar: false
            });
            buildController.setLastBuildInfo(res);
            buildController.printBuildStatusFetchError();
          }
          buildController.setState(buildController.state);
        } else {
          buildController.state.isBuildInProgress = false;
          buildController.setState({
            progressBar: false
          });
          buildController.printBuildStatusFetchError();
        }
      },
      error: function (xhr, status, error) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      }
    });
  }

  voiceBuildStatusApi = (voiceBuildId) => {
    let buildController = this;
    buildController.state.isVoiceBuildInProgress = true;
    buildController.setState(buildController.state);
    $.ajax({
      url: "/api/voice-build-status",
      type: 'GET',
      async: false,
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("access_token")
      },
      data: {
        buildId: voiceBuildId
      },
      success: function (res) {
        if (res.success === true) {
          res = res.result;
          buildController.state.voicePercentage = res.percentage;
          buildController.state.voiceNumEntitiesParsed = res.numEntitiesParsed;
          buildController.state.voiceStatus = res.status;
          buildController.state.details = res.details;
          if (buildController.state.voiceTotalEntitiesTobeParsed == 0) {
            buildController.state.voiceTotalEntitiesTobeParsed = res.totalEntitiesTobeParsed;
            buildController.setState(buildController.state);
          }
          if (res.status == 'COMPLETE') {
            clearTimeout(window.voiceBuildStatusTimeoutHandle);
            buildController.voiceBuildSuccess = true;
            buildController.state.isVoiceBuildInProgress = false;
          } else if (res.status == 'ERROR') {
            clearTimeout(window.voiceBuildStatusTimeoutHandle);
            buildController.state.isVoiceBuildInProgress = false;
            buildController.setState({
              voiceProgressBar: false
            });
            buildController.printBuildStatusFetchError();
          }
          buildController.setState(buildController.state);
        } else {
          buildController.state.isVoiceBuildInProgress = false;
          buildController.setState({
            voiceProgressBar: false
          });
          buildController.printBuildStatusFetchError();
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      }
    });
  }

  onBuildButtonClick = (data) => {
    var buildController = this;
    buildController.startBuildApi();
    if (buildController.state.enableVoice) {
      buildController.state.voiceProgressBar = true;
    }
    buildController.setState({
      progressBar: true
    });
  }

  setLastBuildInfo = (response) => {
    var buildController = this;
    var date = new Date(response.startTime);
    var lastBuildDate = date.toLocaleString();
    buildController.state.recordsPresent = true;
    buildController.state.lastBuildDate = lastBuildDate;
    buildController.state.status = response.status;
    buildController.setState(buildController);
  }

  fetchBuildInfoApi(projectId) {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem('currentProjectId');
      }
    }
    var buildController = this;
    $.ajax({
      url: "/api/last-build-info",
      async: false,
      method: 'GET',
      data: { "projectId": projectId },
      headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
      success: function (res) {
        if (res.success === true) {
          if (res.result === "null") {
            buildController.state.progressBar = false;
            buildController.state.voiceProgressBar = false;
            buildController.state.recordsPresent = false;
            buildController.setState(buildController);
          } else {
            buildController.setLastBuildInfo(res.result.lastBuildInfo)
            var today = new Date();
            var currentTime = today.getTime();
            var differenceBtwTime = (currentTime - res.result.lastBuildInfo.startTime) / 60000;
            var inProgress = false;
            var isVoiceProgress = false;
            if (differenceBtwTime <= 20) {
              if (res.result.lastBuildInfo.status === 'COMPLETE' ||
                res.result.lastBuildInfo.status === 'ERROR') {
                inProgress = false;
              } else {
                inProgress = true;
              }
            }
            if (inProgress) {
              buildController.state.progressBar = true;
              buildController.state.buildId = res.result.lastBuildInfo.id;
              window.buildStatusTimeoutHandle = setInterval(function () {
                buildController.buildStatusApi();
              }, 1000);
            } else {
              buildController.state.progressBar = true;
              buildController.state.status = res.result.lastBuildInfo.status;
              buildController.state.percentage = res.result.lastBuildInfo.percentage;
              buildController.state.totalEntitiesTobeParsed = res.result.lastBuildInfo.totalEntitiesTobeParsed;
              buildController.state.numEntitiesParsed = res.result.lastBuildInfo.numEntitiesParsed;
            }

            if (res.result.lastVoiceBuildInfo != null) {
              if (res.result.lastVoiceBuildInfo.status === 'COMPLETE' ||
                res.result.lastVoiceBuildInfo.status === 'ERROR') {
                isVoiceProgress = false;
              } else {
                isVoiceProgress = true;
              }

              if (isVoiceProgress) {
                buildController.state.voiceProgressBar = true;
                window.voiceBuildStatusTimeoutHandle = setInterval(function () {
                  buildController.voiceBuildStatusApi(res.result.lastVoiceBuildInfo.id);
                }, 1000);
              } else {
                buildController.state.voiceProgressBar = true;
                buildController.state.voiceStatus = res.result.lastVoiceBuildInfo.status;
                buildController.state.voicePercentage = res.result.lastVoiceBuildInfo.percentage;
                buildController.state.voiceTotalEntitiesTobeParsed = res.result.lastVoiceBuildInfo.totalEntitiesTobeParsed;
                buildController.state.voiceNumEntitiesParsed = res.result.lastVoiceBuildInfo.numEntitiesParsed;
                buildController.state.details = res.result.lastVoiceBuildInfo.details;
              }
              buildController.setState(buildController.state);
            }
          }
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      }
    });
  }


  componentDidMount() {
    var thisController = this;
    setTimeout(() => {
      thisController.fetchProjectVoiceSettingApi();
      thisController.fetchBuildInfoApi();
    }, 300);

    document.addEventListener("projectChanged", function (event) {
      thisController.projectId = event.projectId;
      thisController.state.percentage = 0,
        thisController.state.voicePercentage = 0,
        thisController.state.status = null,
        thisController.state.voiceStatus = null,
        thisController.state.progressBar = false,
        thisController.state.voiceProgressBar = false,
        thisController.state.totalEntitiesTobeParsed = 0,
        thisController.state.voiceTotalEntitiesTobeParsed = 0,
        thisController.state.numEntitiesParsed = 0,
        thisController.state.voiceNumEntitiesParsed = 0,
        thisController.state.details = "",
        thisController.state.isCleanBuild = false,
        thisController.state.isBuildInProgress = false,
        thisController.state.isVoiceBuildInProgress = false,
        thisController.fetchProjectVoiceSettingApi(event.projectId);
      thisController.fetchBuildInfoApi(event.projectId);
    });
  }

  componentWillUnmount() {
    clearTimeout(window.buildStatusTimeoutHandle);
    clearTimeout(window.voiceBuildStatusTimeoutHandle)
  }

  checkHandle = (e) => {
    let buildController = this;
    e.target.checked ? buildController.state.isCleanBuild = true :
      buildController.state.isCleanBuild = false;
    buildController.setState(buildController.state);
  }

  fetchProjectVoiceSettingApi = (projectId) => {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem('currentProjectId');
      }
    }
    var buildController = this;
    $.ajax({
      url: "/api/voice-settings",
      async: false,
      method: 'GET',
      data: {
        "projectId": projectId
      },
      headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
      success: function (res) {
        if (res.success === true) {
          if (res.result != null) {
            buildController.state.enableVoice = res.result.enabled;
          } else {
            buildController.state.enableVoice = false;
          }
        } else {
          buildController.state.enableVoice = false;
        }
        buildController.setState(buildController.state);
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      }
    });
  }

  render() {
    var status = this.state.status;
    if (status != null || status != undefined) {
      if (/_/i.test(status)) {
        var replUnSc = status.split("_").join(" ");
        status = replUnSc.split(' ')
          .map(w => w[0].toUpperCase() + w.substr(1).toLowerCase())
          .join(' ')
      } else {
        status = status[0].toUpperCase() + status.substr(1).toLowerCase()
      }
    }

    var voiceStatus = this.state.voiceStatus;
    if (voiceStatus != null || voiceStatus != undefined) {
      if (/_/i.test(voiceStatus)) {
        var replUnSc = voiceStatus.split("_").join(" ");
        voiceStatus = replUnSc.split(' ')
          .map(w => w[0].toUpperCase() + w.substr(1).toLowerCase())
          .join(' ')
      } else {
        voiceStatus = voiceStatus[0].toUpperCase() + voiceStatus.substr(1).toLowerCase()
      }
    }
    return (
      <div>
        {/* for toaster */}
        <link rel="stylesheet" href="./assets/css/ReactToastify.css" />
        <link rel="stylesheet" href="assets/css/toggleButton.css" />
        <div style={{ marginRight: '1%' }}>
          <div className="wrapper" style={{ height: "450px" }}>

            <div className="content-header">
              <div className="container-fluid">
                <div className="row" style={{ marginLeft: '10px', marginTop: '20px' }} >

                  <ToastContainer className="Toast-at-center" />

                  <div className="col-sm-06 p-0">
                    <h1 className="m-0 page-title"></h1></div>
                  <h6 className="nav-item" style={{ color: '#282a65' }}>Build Conversation Model</h6>
                  <br />
                </div>
                <div style={{ display: (this.state.recordsPresent == true) ? "block" : "none" }}>
                  <div style={{ marginLeft: "10px" }}>Last built with the status {this.state.status} on {this.state.lastBuildDate}</div>

                </div>

              </div>
            </div>
            <br />
            <div className="row" style={{ marginLeft: '25px' }}>
              <label>Clean :</label>
              <label class="switch" style={{ marginLeft: '15px' }}>
                <input type="checkbox"
                  onChange={this.checkHandle}
                  checked={this.state.isCleanBuild}
                />
                <span class="slider round"></span>
              </label>
            </div>

            {/*--------------BUILD-BUTTON--------------------------------------------------------------------------  */}
            <div className="container-fluid">
              <div className="row" style={{ marginTop: '10px', marginLeft: '10px' }}>

                <div className="col-sm-3 p-0">
                  <button className="btn action-button"
                    id="addMsg"
                    onClick={this.onBuildButtonClick}
                    disabled={this.state.isBuildInProgress && this.state.isVoiceBuildInProgress}
                    style={{ borderRadius: '4px', width: '30%', height: '30px' }}>Build</button>
                </div>

                <div className="col-sm-4 p-0">
                </div>
                <div className="col-sm-5 p-0"></div>
                <h1></h1>
              </div>
            </div>

            {/* --------------------------------PROGRESS-BAR-------------------------------------------------- */}

            <div className="col-sm-12">
              <div className="row" style={{ marginTop: '20px', marginLeft: '10px' }}>
                <div className="col-sm-6 p-0" style={{
                  display: this.state.progressBar ? 'block' : 'none'
                }}>
                  <div className="nav-item" style={{
                    color: '#282a65', marginLeft: '8px',
                    display: this.state.progressBar ? 'block' : 'none'
                  }}>NLP Model Build</div>
                  <div className="col-sm-8" style={{ marginTop: '20px' }}>
                    <Progress
                      style={{ display: this.state.progressBar ? 'block' : 'none' }}
                      id="build"
                      width="500px"
                      height="50px"
                      rectBorderRadius="1px"
                      percent={parseInt(this.state.percentage)}
                    />
                  </div>
                  <div style={{ marginTop: '20px' }} className="col-sm-8" name="description">
                    <textarea
                      style={{
                        display: this.state.progressBar ? 'block' : 'none',
                        background: 'white', resize: 'none', height: "67px",
                        fontSize: "0.891em"
                      }}
                      className="form-control"
                      value={this.state.status != null ? "Total number of entities to be processed : " +
                        this.state.totalEntitiesTobeParsed + '\n' + "Number of entities processed : "
                        + this.state.numEntitiesParsed + '\n' + "Overall Status : " + status : ""}
                    />
                  </div>
                </div>
                <div className="col-sm-6 p-0" style={{
                  display: this.state.voiceProgressBar ? 'block' : 'none',
                }}>
                  <div className="nav-item" style={{
                    color: '#282a65', marginLeft: '8px',
                    display: this.state.voiceProgressBar ? 'block' : 'none'
                  }}>Voice Model Build</div>
                  <div className="col-sm-8" style={{ marginTop: '20px' }}>
                    <Progress
                      style={{ display: this.state.voiceProgressBar ? 'block' : 'none' }}
                      id="build"
                      width="500px"
                      height="50px"
                      rectBorderRadius="1px"
                      percent={parseInt(this.state.voicePercentage)}
                    />
                  </div>
                  <div style={{ marginTop: '20px' }} className="col-sm-8" name="description">
                    <textarea
                      style={{
                        display: this.state.voiceProgressBar ? 'block' : 'none',
                        background: 'white', resize: 'none', height: "67px",
                        fontSize: "0.891em"
                      }}
                      className="form-control"
                      value={this.state.voiceStatus != null ? "Status : " + voiceStatus + '\n' + "Details : "
                        + this.state.details : ""}
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* --------------------------------TEXT-AREA-------------------------------------------------- */}

          </div>
        </div>
      </div >

    )
  }


}

export default Build;



// WEBPACK FOOTER //
// ./src/projectmgmt/testAndDeploy/Build.js